import React, { useState, useEffect } from "react"
import axios from "axios";
import { useHistory } from 'react-router-dom';
import { baseUrl, localserver, ROUTE_BASE_URL } from '../../../api/common';
import { Link, useParams } from "react-router-dom";
import { encryptSlug, decryptSlug } from "../../../util/encryption"
import Loader from "../../common/Loader";
import Cookies from 'js-cookie';
import { showToast, ToastMessage } from "../../Shared/ToastMessage";

const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8"></circle>
    <path d="m21 21-4.35-4.35"></path>
  </svg>
)

const SettingsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
)

const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
)

export default function CheckInList() {

  const history = useHistory();
  const { id } = useParams()
  const [searchQuery, setSearchQuery] = useState("")
  const [filter, setFilter] = useState("all")

  const [attendees, setAttendees] = useState([]);  
  const [getAttendeesStatus, setGetAttendeesStatus] = useState(false);  

  const isAuthenticated = Cookies.get('userId');

//   useEffect(() => {
//     if (!isAuthenticated) {
//       history.push(`${ROUTE_BASE_URL}/access-denied`);
//     }
//   }, [isAuthenticated, history]);

  const getAttendees = async () => {
    setGetAttendeesStatus(true);
    try {
      const response = await axios.post(`${localserver}/checkin_user_list`,   
       {
           event_id: localStorage.getItem("eventId"),
           check_id: decryptSlug(`${id}`),
           sort_by:""
       }, 
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
      if (response.data.success) {
        const transformedAttendees = response.data.data.map(item => ({
          id: item.attendee_id,
          name: `${item.first_name} ${item.last_name}`.trim(),
          email: item.email,
          ticketId: item.ticket_id,
          ticketName: item.ticket_name,
          checkedIn: item.checkin_status === "Yes",
          checkInTime: null,
          checkInDate: null
        }));
        setAttendees(transformedAttendees);
      } else {
        console.error("Error: Failed to fetch user data")
      }
    } catch (error) {
      console.error("Error fetching events:", error)
    }finally{
     setGetAttendeesStatus(false);   
    }
  }

  const handleCheckIn = async ( ticketId, checkinId ) => {
    
    const userId = localStorage.getItem("loginUserId");
    if (!userId) {
      console.error("User ID not found");
      return;
    }
    try {
      const response = await axios.post(
        `${localserver}/checkin_add`,
        {
          user_id: parseInt(userId),
          event_id: parseInt(localStorage.getItem("eventId")),
          check_id: parseInt(decryptSlug(`${id}`)),
          attendee_id: parseInt(checkinId),
          ticket_id: parseInt(ticketId),
          attendee_in: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data.success) {
        showToast(response.data.message, "success");
        getAttendees();
        console.log("Check-in added successfully");
      } else {
        showToast(response.data.message, "error");
        console.error("Failed to add check-in:", response.data.message);
      }
    } catch (error) {
      console.error("Error adding check-in:", error);
    }
  };

  useEffect(()=>{
    getAttendees()
  },[]);

  // if (getAttendeesStatus) {
  //   return <Loader />
  // }

  if (!isAuthenticated) {
    return (
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#f9fafb",
          padding: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#666666",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "60px 20px",
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>
            <i className="fa fa-user-o"></i>
          </div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#1a1a1a",
            }}
          >
            Access Denied
          </h3>
        </div>
      </div>
    )
  }

  const filteredAttendees = attendees.filter((attendee) => {
    const matchesSearch =
      attendee.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      attendee.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      attendee.ticketName.toLowerCase().includes(searchQuery.toLowerCase())

    let matchesFilter = true
    if (filter === "checked-in") {
      matchesFilter = attendee.checkedIn
    } else if (filter === "not-checked-in") {
      matchesFilter = !attendee.checkedIn
    }

    return matchesSearch && matchesFilter
  })

  const groupedAttendees = filteredAttendees.reduce((acc, attendee) => {
    const firstLetter = attendee.name[0].toUpperCase()
    if (!acc[firstLetter]) {
      acc[firstLetter] = []
    }
    acc[firstLetter].push(attendee)
    return acc
  }, {})

  const renderHeader = () => {
    return (
      <div style={{ marginBottom: "22px" }}>
        <div className="brood_comes_div" style={{ padding: "24px", backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div style={{ fontSize: "24px", color: "#184778", fontWeight: "600" }}>
                Check-In List
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
              <div style={{ position: "relative", width: "250px" }}>
                <i
                  className="fa fa-search"
                  style={{
                    position: "absolute",
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#666666",
                    fontSize: "14px",
                  }}
                ></i>
                <input
                  type="text"
                  placeholder="Search text for names, emails and references"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  style={{
                    padding: "10px 16px 10px 36px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    fontSize: "14px",
                    outline: "none",
                    width: "100%",
                    transition: "border-color 0.2s ease-in-out",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#184778")}
                  onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                />
              </div>
              <div
                className="text-white hover:bg-white/10"
                style={{
                  padding: "8px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  transition: "background-color 0.2s ease",
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)")}
                onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
              >
                <SettingsIcon />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderFilterTabs = () => {
    const tabs = [
      { key: "all", label: `All (${attendees.length})` },
      { key: "checked-in", label: `Checked-In (${attendees && attendees.filter((item)=>item.checkedIn).length})` },
      { key: "not-checked-in", label: `Not Checked-In (${attendees && attendees.filter((item)=>!item.checkedIn).length})` },
    ];

    return (
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "20px 32px",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          marginBottom: "24px",
        }}
      >
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
          {tabs.map((tab) => {
            const isActive = filter === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => setFilter(tab.key)}
                style={{
                  padding: "12px 20px",
                  border: "none",
                  backgroundColor: isActive ? "#184778" : "transparent",
                  color: isActive ? "#ffffff" : "#666666",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  borderRadius: "8px",
                  transition: "all 0.2s ease-in-out",
                  marginRight: "8px",
                  marginBottom: "8px",
                }}
                onMouseOver={(e) => {
                  if (!isActive) {
                    e.target.style.backgroundColor = "#f3f4f6";
                  }
                }}
                onMouseOut={(e) => {
                  if (!isActive) {
                    e.target.style.backgroundColor = "transparent";
                  }
                }}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  const renderAttendeeCard = (attendee) => {
    return (
      <Link
        to={`/events/attendees-checkin-details/${encryptSlug(
          `${attendee.id}`
        )}/${id}`}
      >
        <div
          key={attendee.id}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
            transition:
              "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
            position: "relative",
            marginBottom: "16px",
            cursor: "pointer",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.15)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
          }}
        >
          <div style={{ padding: "24px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    color: "#1a1a1a",
                    fontSize: "18px",
                    fontWeight: "600",
                    display: "block",
                    lineHeight: "1.4",
                    marginBottom: "8px",
                  }}
                >
                  {attendee.name}
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#5B8DB8",
                    marginBottom: "4px",
                  }}
                >
                  {attendee.email}
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666666",
                  }}
                >
                  {attendee.ticketName}
                </div>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <div style={{ textAlign: "right" }}>
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#5B8DB8",
                    }}
                  >
                    {attendee.ticketName}
                  </div>
                  {attendee.checkedIn === false && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleCheckIn(attendee.ticketId, attendee.id);
                      }}
                      style={{
                        marginTop: "8px",
                        padding: "8px 16px",
                        backgroundColor: "#8BC34A",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "500",
                        transition: "background-color 0.2s ease",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = "#7CB342";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "#8BC34A";
                      }}
                    >
                      Check In Now
                    </button>
                  )}
                </div>
                {attendee.checkedIn && (
                  <div
                    style={{
                      backgroundColor: "#8BC34A",
                      borderRadius: "50%",
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CheckIcon style={{ color: "#ffffff" }} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
  };

  const renderGroupedList = () => {
    if (Object.keys(groupedAttendees).length === 0) {
      return (
        <div
          style={{
            textAlign: "center",
            padding: "60px 20px",
            color: "#666666",
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>
            <i className="fa fa-users"></i>
          </div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#1a1a1a",
            }}
          >
            No attendees found
          </h3>
          <p style={{ fontSize: "14px", margin: "0" }}>
            {searchQuery
              ? "Try adjusting your search terms"
              : "No attendees available"}
          </p>
        </div>
      );
    }

    return (
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          padding: "32px",
        }}
      >
        {Object.entries(groupedAttendees)
          .sort()
          .map(([letter, attendeeList]) => (
            <div key={letter}>
              <div
                style={{
                  backgroundColor: "#f3f4f6",
                  padding: "12px 20px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#666666",
                  marginBottom: "16px",
                  borderRadius: "8px",
                }}
              >
                {letter}
              </div>
              {attendeeList.map((attendee) => renderAttendeeCard(attendee))}
            </div>
          ))}
      </div>
    );
  };

  let content;
  if (getAttendeesStatus) {
    content = <Loader />;
  } else {
    content = <div style={{ minHeight: "100vh", backgroundColor: "#f9fafb", padding: "24px" }}>
    {renderHeader()}
    {renderFilterTabs()}
    {renderGroupedList()}      
  </div>;
  }

  return (
    <>
      <ToastMessage />
      {content}
    </>
  )
}